<route>
{
  "meta": {
    "permission": [
      "sequences.add_sequence",
      "sequences.change_sequence"
    ]
  }
}
</route>

<template>
  <v-container fluid>
    <v-card>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <i-toolbar :title="$tc('sequence', 1)" :loading="load"></i-toolbar>
          <v-card-text>
            <v-row class="my-0">
              <v-col cols="12" md="6" lg="4">
                <ValidationProvider
                  vid="model"
                  :name="$t('model')"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    class="py-0"
                    item-text="fields.name"
                    item-value="pk"
                    outlined
                    :error-messages="errors[0]"
                    :items="sequence_list"
                    :label="$tc('model', 1)"
                    v-model="sequence.model"
                    :disabled="!isAdmin"
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <ValidationProvider
                  vid="number_increment"
                  :name="$t('number_increment')"
                  rules="required|numeric"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    name="number_increment"
                    outlined
                    :error-messages="errors[0]"
                    v-model="sequence.number_increment"
                    color="secondary"
                    :label="$tc('number_increment', 1)"
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <ValidationProvider
                  vid="prefix_en"
                  :name="$t('prefix_en')"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    name="prefix_en"
                    outlined
                    :error-messages="errors[0]"
                    v-model="sequence.prefix_en"
                    color="secondary"
                    :label="$tc('prefix_en', 1)"
                    :disabled="!isAdmin"
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <ValidationProvider
                  vid="padding"
                  :name="$t('padding')"
                  rules="required|numeric"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    name="padding"
                    outlined
                    :error-messages="errors[0]"
                    v-model="sequence.padding"
                    color="secondary"
                    :label="$tc('padding', 1)"
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <ValidationProvider
                  vid="next_number"
                  :name="$t('next_number')"
                  rules="required|numeric"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    name="next_number"
                    outlined
                    :error-messages="errors[0]"
                    v-model="sequence.next_number"
                    color="secondary"
                    :label="$tc('next_number', 1)"
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <ValidationProvider
                  vid="prefix_es"
                  :name="$t('prefix_es')"
                  rules=""
                  v-slot="{ errors }"
                >
                  <v-text-field
                    name="prefix_es"
                    outlined
                    :error-messages="errors[0]"
                    v-model="sequence.prefix_es"
                    color="secondary"
                    :label="$tc('prefix_es', 1)"
                    :disabled="!isAdmin"
                  />
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-alert class="title-responsive" type="info" outlined>
              {{ `${$t('example')}: ${calculatedSequence}` }}
            </v-alert>
          </v-card-text>
        </form>
      </ValidationObserver>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      load: false,
      sequence: {
        pk: '',
        prefix_en: '',
        prefix_es: '',
        padding: '',
        number_increment: '',
        next_number: '',
        model: ''
      }
    }
  },
  computed: {
    sequence_list() {
      return [
        {
          pk: 'purchase_order',
          fields: { name: this.$t('purchase_order') }
        },
        {
          pk: 'pdocument',
          fields: { name: this.$t('pdocument') }
        },
        {
          pk: 'receivable',
          fields: { name: this.$t('receivable') }
        },
        {
          pk: 'invoice',
          fields: { name: this.$t('invoice') }
        },
        {
          pk: 'payment',
          fields: { name: this.$tc('payment', 1) }
        },
        {
          pk: 'product',
          fields: { name: this.$tc('product', 1) }
        },
        {
          pk: 'quote',
          fields: { name: this.$t('quote') }
        },
        {
          pk: 'order',
          fields: { name: this.$tc('order', 1) }
        }
      ]
    },
    calculatedSequence() {
      let next = '' + this.sequence.next_number
      let zero = '0'
        .repeat(this.sequence.padding)
        .substring(0, this.sequence.padding - next.length)
      return this.sequence.prefix_en + zero + next
    },
    ...mapGetters({
      isAdmin: 'session/isAdmin'
    })
  },
  watch: {
    'sequence.padding': {
      handler(val) {
        this.sequence.padding = val < 0 ? val * -1 : val
      }
    }
  },
  methods: {
    submit() {
      this.load = true
      if (this.sequence.pk === '' || this.sequence.pk === undefined) {
        this.$api.sequence
          .create({ form: this.sequence })
          .then((response) => {
            if (response.status == 201) {
              this.$toast.success(
                `${this.$tc('sequence', 1)} ${this.$tc('created', 2)}`
              )
              this.$router.push({ name: 'sequence' })
            }
          })
          .catch((error) => {
            console.error(error.response)
          })
          .finally(() => (this.load = false))
      } else {
        this.$api.sequence
          .edit({
            pk: this.sequence.pk,
            form: this.sequence
          })
          .then(() => {
            this.$toast.success(
              `${this.$tc('sequence', 1)} ${this.$tc('edited', 2)}`
            )
            this.$router.push({ name: 'sequence' })
          })
          .finally(() => (this.load = false))
      }
    },
    async getSequence() {
      this.loading = true
      this.validation = this.codification({
        mode: 'decode',
        code: this.$route.params.pk
      })
      if (this.validation === 'create') {
        if (this.$store.getters['utils/getIsloading']) {
          this.$store.dispatch('utils/actionLoading')
        }
      } else {
        this.$api.sequence
          .show({ pk: this.validation })
          .then((res) => {
            this.sequence = res.data
            this.$route.meta.title = this.sequence.model
          })
          .catch(() => this.$router.push({ name: 'sequence' }))
      }
    }
  },
  mounted() {
    this.getSequence()
  }
}
</script>
